import { useEffect, useState } from 'react';
import axios from 'axios';
import { ChevronDown } from 'lucide-react';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { API } from '@/lib/api';


const FALLBACK = [
  { question: "Puis-je essayer avant de m'inscrire ?", answer: "Oui ! Contactez-nous pour réserver un cours d'essai et découvrir notre box, nos coachs et notre communauté." },
  { question: "Y a-t-il un engagement ?", answer: "Non, nos abonnements sont sans engagement. Vous pouvez résilier à tout moment avec un préavis de 2 mois." },
  { question: "Qu'est-ce que le Free Access ?", answer: "Le Free Access est un créneau d'entraînement en accès libre, sans coach. Disponible pour les abonnements 3x/semaine et Illimité." },
  { question: "Les débutants sont-ils les bienvenus ?", answer: "Absolument ! Nos coachs adaptent chaque exercice à votre niveau." },
];

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [ref, isVisible] = useScrollReveal(0.1);
  const [faqs, setFaqs] = useState(FALLBACK);

  useEffect(() => {
    axios.get(`${API}/content/faqs`).then((r) => {
      if (Array.isArray(r.data) && r.data.length > 0) setFaqs(r.data);
    }).catch(() => {});
  }, []);

  return (
    <section ref={ref} data-testid="faq-section" className="section-padding bg-white">
      <div className="container-custom max-w-3xl">
        <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-primary font-semibold text-sm tracking-widest uppercase">FAQ</span>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl text-dark mt-3 mb-4">QUESTIONS FRÉQUENTES</h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={faq.id || idx}
              data-testid={`faq-item-${idx}`}
              className={`border border-border rounded-xl overflow-hidden transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${200 + idx * 80}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-accent/50 transition-colors"
                data-testid={`faq-toggle-${idx}`}
              >
                <span className="font-semibold text-base pr-4">{faq.question || faq.q}</span>
                <ChevronDown className={`h-5 w-5 text-muted-foreground flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === idx ? 'max-h-[400px]' : 'max-h-0'}`}>
                <div className="px-6 pb-5">
                  <p className="text-muted-foreground text-sm leading-relaxed">{faq.answer || faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
